export const OrderWizardActionTypes = {
  LOYALTY_CHANGE: 'LOYALTY_CHANGE',
  INIT_CART: 'INIT_CART',
  GET_PRODUCT_CONFIGURATION: 'GET_PRODUCT_CONFIGURATION',
  UPDATE_LOYALTY: 'UPDATE_LOYALTY',
  POST_ORDER: 'POST_ORDER',
  POST_ORDER_CLEANUP: 'POST_ORDER_CLEANUP',
  ADD_TO_CART: 'ADD_TO_CART',
  REMOVE_FROM_CART: 'REMOVE_FROM_CART',
  CLEAR_CART: 'CLEAR_CART',
  COMPANY_SEARCH: 'COMPANY_SEARCH',
  REGISTER: 'REGISTER'
}
